import {
  Box,
  IconButton,
} from '@mui/material';
import {styled} from '@mui/system';

export const MainContainerContent = styled(Box)(({theme}) => ({
  // maxWidth: '550px',
}));

export const EventContainer = styled(Box)(({theme}) => ({
  flexDirection: 'column',
  backgroundColor: 'white',
  flexGrow: '1',
  padding: 0,
  // width: '100%',
  // height: '100%',
  // overflow: 'auto',
}));

export const MainContainer = styled(Box)(({theme}) => ({
  flexGrow: '1',
  padding: '24px 40px 8px',
  backgroundColor: theme.palette.background.default,
  minWidth: 'fit-content',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '0px 20px 8px',
  },
}));

export const EventStack = styled(Box)(({theme}) => ({
  flexDirection: 'row',
  flexWrap: 'nowrap',
  height: '100%',
  background: theme.palette.background.default,
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
  },
}));

export const CancellationsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  width: '450px',
  margin: 'auto',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '0px 16px 8px',
  },
}));

export const NavButton = styled(IconButton)(({theme}) => ({
  position: 'fixed',
  left: '18px',
  top: '12px',
  zIndex: 9999, // Must be larger than ZmWebHeader's z-index
  fontWeight: 'bolder',
  height: '1rem',
  width: '1rem',
  color: theme.palette.text.primary,
}));
